import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
/* eslint-disable dot-notation */
import { useMemo } from 'react';
import { stageOrder } from "../../../../util/sortRequirementsList";
import { useReduxSelector } from '@applyboard/ab-common';
import { createApplicationRequirementsSelector } from "../../../../store/selectors/requirements";
var useRequirementsOutstanding = function useRequirementsOutstanding(application) {
  var _application$status, _application$status2, _application$status3, _application$status4, _application$status5, _application$status6;
  var applicationRequirements = useReduxSelector(createApplicationRequirementsSelector());

  /**
   * Count how many outstanding requirements are there on each stage
   */
  var stageReqsOutstanding = useMemo(function () {
    var returnValue = {};
    stageOrder.forEach(function (stg) {
      returnValue[stg] = 0;
    });
    if (applicationRequirements && applicationRequirements.length > 0) {
      applicationRequirements.forEach(function (req) {
        if (req.required_state === 'required_state_required' && req.status !== 'status_completed') {
          returnValue[req.current_stage.name] += 1;
        }
      });
    }
    return returnValue;
  }, [applicationRequirements]);
  var disableReadyToSubmit = stageReqsOutstanding && stageReqsOutstanding['pre-submission'] > 0 && !(application !== null && application !== void 0 && (_application$status = application.status) !== null && _application$status !== void 0 && _application$status.ready_to_submit);
  var prePaymentRequirementsOutstanding = stageReqsOutstanding && stageReqsOutstanding['pre-payment'] > 0 && !(application !== null && application !== void 0 && (_application$status2 = application.status) !== null && _application$status2 !== void 0 && _application$status2.ready_to_submit);
  var postSubmissionRequirementsOutstanding = stageReqsOutstanding && stageReqsOutstanding['post-submission'] > 0;
  var submissionRequirementsOutstanding = stageReqsOutstanding && stageReqsOutstanding['submission'] && !(application !== null && application !== void 0 && (_application$status3 = application.status) !== null && _application$status3 !== void 0 && _application$status3.submitted);
  var admissionRequirementsOutstanding = stageReqsOutstanding && stageReqsOutstanding['admission'] > 0;
  var refundRequirementsOutstanding = stageReqsOutstanding && stageReqsOutstanding['refund'] && (application === null || application === void 0 ? void 0 : (_application$status4 = application.status) === null || _application$status4 === void 0 ? void 0 : _application$status4.refund_in_progress);
  var deferralRequirementsOutstanding = stageReqsOutstanding && stageReqsOutstanding['deferral'] && (application === null || application === void 0 ? void 0 : (_application$status5 = application.status) === null || _application$status5 === void 0 ? void 0 : _application$status5.deferral_in_progress);
  var readyToEnrollRequirementsOutstanding = stageReqsOutstanding && stageReqsOutstanding['pre-arrival'] && !(application !== null && application !== void 0 && (_application$status6 = application.status) !== null && _application$status6 !== void 0 && _application$status6.ready_to_enroll);
  return {
    admissionRequirementsOutstanding: admissionRequirementsOutstanding,
    deferralRequirementsOutstanding: deferralRequirementsOutstanding,
    disableReadyToSubmit: disableReadyToSubmit,
    prePaymentRequirementsOutstanding: prePaymentRequirementsOutstanding,
    postSubmissionRequirementsOutstanding: postSubmissionRequirementsOutstanding,
    readyToEnrollRequirementsOutstanding: readyToEnrollRequirementsOutstanding,
    refundRequirementsOutstanding: refundRequirementsOutstanding,
    submissionRequirementsOutstanding: submissionRequirementsOutstanding
  };
};
export default useRequirementsOutstanding;